var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "seo-audit" }, [
    _c("div", { staticClass: "score-wrap" }, [
      _c("div", { staticClass: "score-card" }, [
        _c("span", { staticClass: "text-muted" }, [_vm._v("Current Score")]),
        _vm._v(" "),
        _c("div", { staticClass: "score" }, [
          _c("span", { staticClass: "current" }, [
            _vm._v(_vm._s(_vm.reportData?.analysis_content?.score || 0)),
          ]),
          _vm._v(" / "),
          _c("span", [_vm._v("100")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "progress" }, [
          _c("div", {
            staticClass: "progress-bar bg-success",
            style: {
              width: (_vm.reportData?.analysis_content?.score ?? 0) + "%",
            },
            attrs: {
              role: "progressbar",
              "aria-valuenow": _vm.reportData?.analysis_content?.score ?? 0,
              "aria-valuemin": "0",
              "aria-valuemax": "100",
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "score-card" }, [
        _c("span", { staticClass: "text-muted" }, [_vm._v("Issues Found")]),
        _vm._v(" "),
        _c("p", { staticClass: "issues-count" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.issuesCountBySeverity.total ?? "-") +
              "\n      "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "badges-list" }, [
          _vm.issuesCountBySeverity.critical
            ? _c("div", { staticClass: "badge badge-danger" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.issuesCountBySeverity.critical) +
                    " Critical\n        "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.issuesCountBySeverity.warning
            ? _c("div", { staticClass: "badge badge-warning" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.issuesCountBySeverity.warning) +
                    " Warning\n        "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.issuesCountBySeverity.info
            ? _c("div", { staticClass: "badge badge-info" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.issuesCountBySeverity.info) +
                    " Info\n        "
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "score-card" }, [
        _c("span", { staticClass: "text-muted" }, [_vm._v("Potential Gain")]),
        _vm._v(" "),
        _c("div", { staticClass: "gains-card" }, [
          _c("div", { staticClass: "gains-item" }, [
            _c("span", [
              _vm._v(
                "+ " +
                  _vm._s(
                    _vm.reportData?.analysis_content?.potential_gain ?? "-"
                  )
              ),
            ]),
            _vm._v(" points\n        "),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "text-muted" }, [
            _vm._v("After optimization"),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "analysis-v2 mt-3" }, [
      _vm.analysisExecutiveSummary.length
        ? _c("div", { staticClass: "panel-card collapsible-panel" }, [
            _c(
              "div",
              {
                staticClass: "panel-head clickable",
                on: {
                  click: function ($event) {
                    _vm.isExecutiveSummaryExpanded =
                      !_vm.isExecutiveSummaryExpanded
                  },
                },
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("i", {
                  staticClass: "bi panel-chevron",
                  class: _vm.isExecutiveSummaryExpanded
                    ? "bi-chevron-down"
                    : "bi-chevron-right",
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isExecutiveSummaryExpanded,
                    expression: "isExecutiveSummaryExpanded",
                  },
                ],
                staticClass: "panel-body",
              },
              [
                _c(
                  "ul",
                  { staticClass: "exec-list mb-0" },
                  _vm._l(_vm.analysisExecutiveSummary, function (row, i) {
                    return _c(
                      "li",
                      { key: "exec-" + i, staticClass: "exec-item" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "severity-badge",
                            class: _vm.severityBadgeClass(row.severity),
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(row.severity) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "exec-text" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(row.text) +
                              "\n            "
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasQuantitativeAnalysis
        ? _c("div", { staticClass: "panel-card collapsible-panel mt-3" }, [
            _c(
              "div",
              {
                staticClass: "panel-head clickable",
                on: {
                  click: function ($event) {
                    _vm.isQuantitativeAnalysisExpanded =
                      !_vm.isQuantitativeAnalysisExpanded
                  },
                },
              },
              [
                _vm._m(1),
                _vm._v(" "),
                _c("i", {
                  staticClass: "bi panel-chevron",
                  class: _vm.isQuantitativeAnalysisExpanded
                    ? "bi-chevron-down"
                    : "bi-chevron-right",
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isQuantitativeAnalysisExpanded,
                    expression: "isQuantitativeAnalysisExpanded",
                  },
                ],
                staticClass: "panel-body",
              },
              [
                _c(
                  "table",
                  {
                    staticStyle: {
                      width: "100%",
                      "border-collapse": "collapse",
                      background: "#fff",
                    },
                  },
                  [
                    _vm._m(2),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.quantitativeRows, function (row, i) {
                        return _c(
                          "tr",
                          {
                            key: "qa-" + i,
                            staticStyle: {
                              "border-bottom": "1px solid #e5e7eb",
                            },
                          },
                          [
                            _c(
                              "td",
                              {
                                staticStyle: {
                                  padding: "12px",
                                  "font-weight": "600",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(row.section) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", { staticStyle: { padding: "12px" } }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(row.metric) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticStyle: { padding: "12px" } }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(row.actual) +
                                  "\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticStyle: {
                                  padding: "12px",
                                  color: "#64748b",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(row.recommended) +
                                    "\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticStyle: {
                                  padding: "12px",
                                  "text-align": "right",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      padding: "4px 10px",
                                      "border-radius": "12px",
                                      "font-size": "12px",
                                    },
                                    style: {
                                      background:
                                        row.status === "pass"
                                          ? "#dcfce7"
                                          : row.status === "fail"
                                          ? "#fee2e2"
                                          : "#fef3c7",
                                      color:
                                        row.status === "pass"
                                          ? "#166534"
                                          : row.status === "fail"
                                          ? "#991b1b"
                                          : "#92400e",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(row.status) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.reportData?.analysis_content?.recommendations
        ? _c(
            "div",
            {
              staticClass:
                "panel-card collapsible-panel mt-3 recommendations-panel",
            },
            [
              _c(
                "div",
                {
                  staticClass: "panel-head clickable",
                  on: {
                    click: function ($event) {
                      _vm.isRecommendationsExpanded =
                        !_vm.isRecommendationsExpanded
                    },
                  },
                },
                [
                  _c("div", { staticClass: "panel-head-content" }, [
                    _c("div", { staticClass: "panel-title" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.reportData?.analysis_content
                              ?.recommendations_title || "Recommendations"
                          ) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.reportData?.analysis_content
                      ?.recommendations_description
                      ? _c("span", { staticClass: "panel-sub text-muted" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.reportData.analysis_content
                                  .recommendations_description
                              ) +
                              "\n          "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "bi panel-chevron",
                    class: _vm.isRecommendationsExpanded
                      ? "bi-chevron-down"
                      : "bi-chevron-right",
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isRecommendationsExpanded,
                      expression: "isRecommendationsExpanded",
                    },
                  ],
                  staticClass: "panel-body recommendations-body",
                },
                _vm._l(
                  _vm.reportData.analysis_content.recommendations,
                  function (section, sectionKey) {
                    return _c(
                      "div",
                      {
                        key: sectionKey,
                        staticClass: "recommendation-section",
                      },
                      [
                        _c(
                          "h6",
                          { staticClass: "recommendation-section-title" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.formatSectionTitle(sectionKey)) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "recommendation-table-wrap" },
                          [
                            _c(
                              "table",
                              { staticClass: "recommendation-table" },
                              [
                                _vm._m(3, true),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  _vm._l(section.rows, function (row, i) {
                                    return _c("tr", { key: i }, [
                                      _c("td", { staticClass: "col-issue" }, [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(row.issue) +
                                            "\n                  "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("td", { staticClass: "col-actual" }, [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(row.actual_vs_recommended) +
                                            "\n                  "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "col-recommendation" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(row.recommendation) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ])
                                  }),
                                  0
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        section.recommended_keywords?.length
                          ? _c("div", { staticClass: "recommended-keywords" }, [
                              _c("span", { staticClass: "keywords-label" }, [
                                _vm._v(
                                  _vm._s(
                                    section.recommended_keywords_label ||
                                      "Recommended keywords:"
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "keywords-list" },
                                _vm._l(
                                  section.recommended_keywords,
                                  function (keyword, ki) {
                                    return _c(
                                      "span",
                                      { key: ki, staticClass: "keyword-pill" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(keyword) +
                                            "\n              "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ])
                          : _vm._e(),
                      ]
                    )
                  }
                ),
                0
              ),
            ]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "analysis-v2 mt-3" }, [
      _vm.reportData?.analysis_content?.issues?.length
        ? _c("div", { staticClass: "panel-card collapsible-panel" }, [
            _c(
              "div",
              {
                staticClass: "panel-head clickable",
                on: {
                  click: function ($event) {
                    _vm.isSummaryExpanded = !_vm.isSummaryExpanded
                  },
                },
              },
              [
                _c("div", { staticClass: "panel-head-content" }, [
                  _c("div", { staticClass: "panel-title" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.reportData?.analysis_content?.summary_title ||
                            "Summary"
                        ) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.reportData?.analysis_content?.summary_description
                    ? _c("span", { staticClass: "panel-sub text-muted" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.reportData.analysis_content
                                .summary_description
                            ) +
                            "\n          "
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("i", {
                  staticClass: "bi panel-chevron",
                  class: _vm.isSummaryExpanded
                    ? "bi-chevron-down"
                    : "bi-chevron-right",
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isSummaryExpanded,
                    expression: "isSummaryExpanded",
                  },
                ],
                staticClass: "panel-body",
              },
              [
                _c(
                  "div",
                  { staticClass: "issues-list" },
                  _vm._l(
                    _vm.reportData?.analysis_content?.issues || [],
                    function (issue, idx) {
                      return _c(
                        "div",
                        {
                          key: "issue-" + idx,
                          staticClass: "issue-item",
                          class: {
                            "is-critical": issue?.severity === "critical",
                            "is-warning": issue?.severity === "warning",
                            "is-info": issue?.severity === "info",
                          },
                        },
                        [
                          _c("div", { staticClass: "issue-main" }, [
                            _c("div", { staticClass: "issue-title-line" }, [
                              _c("div", { staticClass: "issue-title" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(issue?.title) +
                                    "\n                "
                                ),
                              ]),
                              _vm._v(" "),
                              issue?.category
                                ? _c(
                                    "div",
                                    { staticClass: "pill pill-light ms-2" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(issue.category) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            issue?.explanation
                              ? _c(
                                  "div",
                                  { staticClass: "issue-subtitle text-muted" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(issue.explanation) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            issue?.impact
                              ? _c("div", { staticClass: "issue-details" }, [
                                  _c(
                                    "div",
                                    { staticClass: "detail text-muted" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(issue.impact) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "issue-side" }, [
                            _c(
                              "span",
                              {
                                staticClass: "severity-badge",
                                class: {
                                  "badge-danger":
                                    issue?.severity === "critical",
                                  "badge-warning":
                                    issue?.severity === "warning",
                                  "badge-info": issue?.severity === "info",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(issue?.severity) +
                                    "\n              "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      )
                    }
                  ),
                  0
                ),
              ]
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "panel-head-content" }, [
      _c("div", { staticClass: "panel-title" }, [
        _vm._v("\n            Executive Summary\n          "),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "panel-sub text-muted" }, [
        _vm._v(
          "\n            Key takeaways prioritized by severity\n          "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "panel-head-content" }, [
      _c("div", { staticClass: "panel-title" }, [
        _vm._v("\n            Quantitative Analysis\n          "),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "panel-sub text-muted" }, [
        _vm._v(
          "\n            Retailer rules and structural guidelines only\n          "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", { staticStyle: { background: "#f8fafc" } }, [
        _c(
          "th",
          {
            staticStyle: {
              padding: "12px",
              "text-align": "left",
              "border-bottom": "1px solid #e5e7eb",
            },
          },
          [_vm._v("\n                Section\n              ")]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticStyle: {
              padding: "12px",
              "text-align": "left",
              "border-bottom": "1px solid #e5e7eb",
            },
          },
          [_vm._v("\n                Metric\n              ")]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticStyle: {
              padding: "12px",
              "text-align": "left",
              "border-bottom": "1px solid #e5e7eb",
            },
          },
          [_vm._v("\n                Actual\n              ")]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticStyle: {
              padding: "12px",
              "text-align": "left",
              "border-bottom": "1px solid #e5e7eb",
            },
          },
          [_vm._v("\n                Recommended\n              ")]
        ),
        _vm._v(" "),
        _c(
          "th",
          {
            staticStyle: {
              padding: "12px",
              "text-align": "right",
              "border-bottom": "1px solid #e5e7eb",
            },
          },
          [_vm._v("\n                Status\n              ")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "col-issue" }, [
          _vm._v("\n                    Issue\n                  "),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "col-actual" }, [
          _vm._v(
            "\n                    Actual vs. Recommended\n                  "
          ),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "col-recommendation" }, [
          _vm._v("\n                    Recommendation\n                  "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }